import { render, staticRenderFns } from "./subGroup.vue?vue&type=template&id=14baa28f&scoped=true&"
import script from "./subGroup.vue?vue&type=script&lang=js&"
export * from "./subGroup.vue?vue&type=script&lang=js&"
import style0 from "./subGroup.vue?vue&type=style&index=0&id=14baa28f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14baa28f",
  null
  
)

export default component.exports